import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormBacteriumCountText } from './FormBacteriumCountText';
import { DeleteBacteriumCountText } from './DeleteBacteriumCountText';
import { Dialog } from 'primereact/dialog';

export const ModalBacteriumCounText = (props) => {

    const {
        modal, tittle, closeDialogB, method,
        name,
        handleInputChange, loading,
        saveCreate,saveUpdateBacterium
    } = props;

    return (
        <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialogB}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                    ? <FormBacteriumCountText
                        button={"Crear"}
                        {...{ closeDialogB, loading,name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormBacteriumCountText
                            button={"Actualizar"}
                            {...{ closeDialogB, loading,name, handleInputChange,methodAction: saveUpdateBacterium }} />
                        :
                        null
            }
        </Dialog>
    )
}
